import { NAME_REGEX } from 'shared/utils/string/name';
import { z } from 'zod';

export const nameValidationMessages = {
  required: 'Please enter your legal name.',
  invalid_minimum_length: 'Minimum 2 characters',
  invalid_characters: 'You can only use letters, hyphens, and apostrophes.',
};

export const nameSchema = z
  .string({ error: nameValidationMessages.required })
  .min(1, { error: nameValidationMessages.required })
  .min(2, { error: nameValidationMessages.invalid_minimum_length })
  .regex(NAME_REGEX, {
    error: nameValidationMessages.invalid_characters,
  });
